<template>
  <div style="display:flex:flex-wrap:wrap">
    <TopHeader />
    <ContactHeader />
    <MainMenu />
    <BreadcrumbMain v-if="showBread" />
    <router-view></router-view>
    <Kpis v-if="showBread" />
    <TestimonialesSlider v-if="showBread" />
    <FooterX />
    <Toast position="top-right" />
  </div>
</template>

<script>
import FooterX from "./components/footer.vue";
import TopHeader from "./components/layout/top_header.vue";
import ContactHeader from "./components/layout/contact_header.vue";
import MainMenu from "./components/layout/main_menu.vue";
import BreadcrumbMain from "./components/layout/breadcrumb.vue";
import Kpis from "./components/layout/kpis.vue";
import TestimonialesSlider from "./components/layout/testimoniales_slider.vue";
export default {
  name: "App",
  components: {
    FooterX,
    TopHeader,
    ContactHeader,
    MainMenu,
    BreadcrumbMain,
    Kpis,
    TestimonialesSlider,
  },
  computed: {
    showBread() {
      return this.$route.name != "main";
    }
  },
  watch: {
    $route() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  }
};
</script>

<style>
html {
  height: 100%;
  overflow-x: hidden;
}
body {
  height: 100%;
}

/* @import url("https://fonts.googleapis.com/css2?family=Lato:wght@300&display=swap"); */
@import url('https://fonts.googleapis.com/css2?family=Lato:wght@300;400&display=swap');
* {
  font-family: "Lato", sans-serif;
}
#app {
  font-family: "Lato", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}

/* scrool style */
::-webkit-scrollbar {
  width: 4px !important;
}

/* Track */

::-webkit-scrollbar-track {
  border-radius: 6px !important;
}

/* Handle */

::-webkit-scrollbar-thumb {
  background: #17689d !important;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #2b9cd5 !important;
}

.mdi {
  font-size: 20px !important;
}

/* template*/
html,
body {
  height: 100%;
}

body {
  margin: 0px;
  padding: 0px;
  background-color: #ffffff;
  font-family: "Lato", Helvetica, Arial, sans-serif;
  font-size: 10pt;
  color: #4f4f4f;
}

h1,
h2,
h3 {
  margin: 0px;
  padding: 0px;
}

p,
ol,
ul {
  margin-top: 0px;
}

p {
  line-height: 180%;
}

a {
  color: #17689d;
}

a:hover {
  text-decoration: none;
}

a img {
  border: none;
}

img.border {
}

img.alignleft {
  float: left;
  margin-right: 40px;
}

img.alignright {
  float: right;
}

img.aligncenter {
  margin: 0px auto;
}

hr {
  border-top: solid rgb(173, 173, 173) !important;
  border-width: 1px 0 0 0;
  margin: 1rem 0;
}

.divisor {
  border: 1px solid #bfbfbf;
  width: 100%;
  margin-top: 12px;
  margin-bottom: 12px;
}

#wrapper {
  overflow: hidden;
  background: url("assets/layout/images/page-wrapper.jpg") repeat;
}

.clearfix {
  clear: both;
}

.containerFull {
  width: 100%;
  background-color: #f8f8f8;
}

.parrafo {
  font-size: 1.3rem;
  text-align: justify;
  line-height: 40px;
  margin-bottom: 30px;
}

.alturaMinima {
  min-height: 700px;
}

.container-resizable {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  padding: 50px 300px;
  height: auto;
  align-items: center;
}

.titulo-admin{
  color: #063165;
  font-size: 30px;
  font-weight: bold;
}

@media screen and (max-width: 1200px) {
  .container {
    padding-left: 10px;
    padding-right: 10px;
  }
  .titulo-admin{
    color: #063165;
    font-size: 20px;
    font-weight: bold;
  }
}
</style>
